module.exports = __webpack_public_path__ + "media/69.f6b2f5bd.wav";